import { createAsyncThunk } from '@reduxjs/toolkit';
import { Users, } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import { FindUserList } from './interface';

export const findDashboardUser = createAsyncThunk(
  'dashboardUser/findDashboardUser',
  async (values: FindUserList, { rejectWithValue }) => {
    try {
      const response = await Users.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);